<template>
<div v-if="isShow && !isShowDetail">
    <div v-if="!isShowAutoWord && !isShowDemoUserStatus1">
        <header>
            自己紹介
            <div class="h-left">
                <a @click="$emit('close')"><img src="~@/assets/images/icon02.svg" /></a>
            </div>
        </header>
        <div id="wrap">
            <div class="txt-area">
                <div class="btn4">
                    <a @click="isShowAutoWord = true">例文から自己紹介作成</a>
                </div>

                <textarea name="" class="self-introduction1" placeholder="自己紹介文を入力" v-model="formData.user_status" :maxlength="maxLength"></textarea>
                <div class="clearfix">
                    <div class="self-introduction2">※20文字以上入力してください</div>
                    <div class="self-introduction3">{{lengthContent}}/{{maxLength}}</div>
                </div>

                <p class="b">書き方でお困りですか？</p>
                <div class="btn4">
                    <a @click="isShowDemoUserStatus1 = true"><i class="fas fa-question-circle"></i>魅力的な自己紹介の書き方を見る</a>
                </div>
                <div class="btn4">
                    <a @click="showDemoUserDetail()"><i class="fas fa-user"></i>他の会員の自己紹介を見る</a>
                </div>
            </div>

            <div :class="formData.user_status ? 'btn1' : 'btn3'"><a @click="$emit('submit', formData)">保存</a></div>
        </div>
    </div>
    <div v-else>
        <autoWordUserStatus :isShow="isShowAutoWord" @getValue="getUserStatus" @close="this.isShowAutoWord = false"></autoWordUserStatus>
        <demoUserStatus1 :isShow="isShowDemoUserStatus1" @close="isShowDemoUserStatus1 = false"></demoUserStatus1>
    </div>
</div>
<detail v-if="isShowDetail" :idUser="idUser" @close="closeDetail"></detail>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import autoWordUserStatus from "./autoWordUserStatus"
import demoUserStatus1 from "./demoUserStatus1"
import detail from "../../register/component/detail"
import CONSTANTS from "@/constants"
export default {
    components: {
        autoWordUserStatus,
        demoUserStatus1,
        detail,
    },
    props: {
        isShow: Boolean,
        value: String
    },
    emits: ['close'],
    data: () => ({
        formData: {
            user_status: null,
        },
        // isMain: true,
        isShowAutoWord: false,
        isShowDemoUserStatus1: false,
        isShowDetail: false,
        idUser: null,
        maxLength: 500
    }),
    mounted() {
        this.formData.user_status = this.value
    },
    computed: {
        ...mapGetters(['metadata', 'userDetail']),

        lengthContent() {
            if (this.formData.user_status)
                return this.formData.user_status.length
                
            return 0
        }
    },
    watch: {
        isShowDemoUserStatus1() {
            window.scrollTo(0, 0)
        },
        isShowAutoWord() {
            window.scrollTo(0, 0)
        }
    },
    methods: {
        getUserStatus(value) {
            // this.isMain = true
            this.isShowAutoWord = false
            this.formData.user_status = value
        },
        showDemoUserDetail() {
            this.isShowDetail = true
            if (this.userDetail.sex == CONSTANTS.MALE) {
                this.idUser = this.metadata.kara_male;
            } else {
                this.idUser = this.metadata.kara_female;
            }
        },
        closeDetail() {
            this.isShowDetail = false
        },
    },
};
</script>
